<div class="p-3">
  <div class="row">
    <div class="col-24 col-sm-10">
      <div class="d-flex align-items-center justify-content-between form-density-1 mb-3">
        <h4 class="my-1 d-flex gap-1 align-items-center">
          <span>{{ 'AI_IMAGE_GENERATION.SELECT_PRESET' | translate }}</span>
        </h4>

        <mat-form-field appearance="outline" class="form-field-condensed">
          <mat-select
            appearance="outline"
            (selectionChange)="onSelectPreset($event.value)"
            [(value)]="selectedPreset"
            [compareWith]="compareById"
            placeholder="{{ 'AI_IMAGE_GENERATION.SELECT_PRESET' | translate }}"
          >
            <mat-option [value]="{ id: null }">{{
              'AI_IMAGE_GENERATION.CUSTOM_PRESET' | translate
            }}</mat-option>
            @for (preset of promptPresets; track preset.id) {
              <mat-option [value]="preset">
                {{ preset.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <p class="mt-3 mb-0">{{ 'AI_IMAGE_GENERATION.IDENTIFIER_IMAGE' | translate }}</p>
      <h4 class="mt-4 mb-2 d-flex gap-1 align-items-center">
        <span class="step-number">1</span>
        <span>{{ 'AI_IMAGE_GENERATION.PERSONAL_UPLOADS' | translate }}</span>
      </h4>
      <mpa-file-uploader-tiles
        [indexFrom]="1"
        [presetImages]="selectedPreset?.medias"
        (imagesChanged)="onImagesChanged($event)"
      ></mpa-file-uploader-tiles>

      <h4 class="mt-5 mb-2 d-flex gap-1 align-items-center">
        <span class="step-number">2</span>
        <span>{{ 'AI_IMAGE_GENERATION.SELECT_FROM_GALLERY' | translate }}</span>
      </h4>
      <div class="gallery-grid">
        @for (entry of imagesList; track trackByImageId($index, entry.image)) {
          <button
            type="button"
            class="gallery-tile"
            [class.selected]="isSelectedImage(entry.image)"
            (click)="onSelectImage(entry.image)"
          >
            <img
              [src]="$safeNavigationMigration(entry.image?.getImageByFormat('xsmall')?.url)"
              [alt]="entry.image.name"
              [attr.title]="entry.inventory"
              draggable="false"
            />
            @if (isSelectedImage(entry.image)) {
              <span class="check-badge"><mat-icon>check</mat-icon></span>
              <span class="image-index">{{ getSelectedImageNumber(entry.image) }}</span>
            }
          </button>
        }
      </div>

      @if (!imagesList.length) {
        <div>{{ 'AI_IMAGE_GENERATION.EMPTY_GALLERY' | translate }}</div>
      }

      <h4 class="mt-5 mb-1 d-flex gap-1 align-items-center">
        <span class="step-number">3</span>
        <span>{{ 'AI_IMAGE_GENERATION.INFO_GENERATION' | translate }}</span>
      </h4>

      <!-- Prompt input -->
      <mat-form-field appearance="outline" class="w-100 mt-2" subscriptSizing="dynamic">
        <mat-label>{{ 'AI_IMAGE_GENERATION.PROMPT' | translate }}</mat-label>
        <textarea
          matInput
          [(ngModel)]="selectedPreset.prompt"
          placeholder="{{ 'AI_IMAGE_GENERATION.PROMPT_PLACEHOLDER' | translate }}"
          rows="4"
          (ngModelChange)="setCustomPreset()"
        ></textarea>
      </mat-form-field>

      <!-- Aspect ratio and resolution inputs -->
      <div class="mt-3 d-flex gap-3 align-items-start">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>{{ 'AI_IMAGE_GENERATION.ASPECT_RATIO' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedAspectRatio" (ngModelChange)="setCustomPreset()">
            @for (aspectRatio of aspectRatios; track aspectRatio) {
              <mat-option [value]="aspectRatio">
                @if (aspectRatio === originalAspectRatio) {
                  {{ 'AI_IMAGE_GENERATION.ASPECT_RATIO_ORIGINAL' | translate }}
                } @else {
                  {{ aspectRatio }}
                }
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="image-size-field" subscriptSizing="dynamic">
          <mat-label>{{ 'AI_IMAGE_GENERATION.RESOLUTION' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedImageSize" (ngModelChange)="setCustomPreset()">
            @for (imageSize of imageSizes; track imageSize) {
              <mat-option [value]="imageSize">{{ imageSize }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="mt-4 d-flex justify-content-end gap-2">
        <button mat-stroked-button color="primary" (click)="onResetAll()">
          {{ 'AI_IMAGE_GENERATION.RESET_ALL' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="isLoading || !selectedPreset?.prompt || !selectedImages.length"
          (click)="onGenerate()"
        >
          <mat-icon>auto_awesome</mat-icon>
          {{ 'AI_IMAGE_GENERATION.GENERATE' | translate }}
        </button>
      </div>
    </div>

    <div class="col-24 col-sm-14 mt-4 mt-sm-0">
      <div class="view-switch">
        <mat-button-toggle-group aria-label="Compare view">
          <mat-button-toggle [checked]="compareView === null" (click)="setCompareView(null)">
            @if (generatedImage) {
              <span>
                {{ 'AI_IMAGE_GENERATION.GENERATED_IMAGE' | translate }}
              </span>
            } @else {
              <span>
                {{ 'AI_IMAGE_GENERATION.SELECTED_IMAGE' | translate }}
              </span>
            }
          </mat-button-toggle>
          <mat-button-toggle [checked]="compareView === 'slider'" (click)="setCompareView('slider')">
            {{ 'AI_IMAGE_GENERATION.COMPARE' | translate }}
          </mat-button-toggle>
          <mat-button-toggle
            [value]="compareView === 'before' ? 'before' : 'after'"
            [checked]="compareView === 'before' || compareView === 'after'"
            (click)="setCompareView(compareView === 'before' ? 'after' : 'before')"
          >
            <span class="d-flex align-items-center gap-1">
              {{ 'AI_IMAGE_GENERATION.TOGGLE' | translate }}
              (
              @if (compareView === 'before') {
                {{ 'AI_IMAGE_GENERATION.BEFORE' | translate }}
              } @else {
                {{ 'AI_IMAGE_GENERATION.AFTER' | translate }}
              }
              )
            </span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="preview-panel">
        @if (generatedImage && compareImage && compareView === 'slider') {
          <div
            class="compare-container"
            (pointerdown)="onComparePointerDown($event)"
            (pointermove)="onComparePointerMove($event)"
            (pointerup)="onComparePointerUp($event)"
            (pointercancel)="onComparePointerUp($event)"
          >
            <img
              class="compare-img"
              [src]="compareImage.url"
              [alt]="compareImage.name"
              [style.clip-path]="'inset(0 ' + (100 - sliderPosition) + '% 0 0)'"
            />
            <div class="compare-top" [style.clip-path]="'inset(0 0 0 ' + sliderPosition + '%)'">
              <img class="compare-img" [src]="generatedImage.url" [alt]="'AI ' + selectedPreset?.prompt" />
            </div>
            <div class="compare-divider" [style.left.%]="sliderPosition">
              <span
                class="compare-handle"
                role="slider"
                tabindex="0"
                aria-valuemin="0"
                aria-valuemax="100"
                [attr.aria-valuenow]="sliderPosition"
                [attr.aria-label]="'AI_IMAGE_GENERATION.COMPARE' | translate"
                (keydown)="onCompareKeydown($event)"
              >
                <mat-icon>chevron_left</mat-icon>
                <mat-icon>chevron_right</mat-icon>
              </span>
            </div>
            <mat-chip color="primary" class="compare-label before">
              {{ 'AI_IMAGE_GENERATION.BEFORE' | translate }}
            </mat-chip>
            <mat-chip color="primary" class="compare-label after">
              {{ 'AI_IMAGE_GENERATION.AFTER' | translate }}
            </mat-chip>
          </div>
        } @else if (compareView === 'before' && compareImage) {
          <img [src]="compareImage.url" [alt]="'Selected image'" />
        } @else if (generatedImage) {
          <img [src]="generatedImage.url" [alt]="'AI ' + selectedPreset?.prompt" />
        } @else if (compareImage) {
          <img [src]="compareImage.url" [alt]="'Selected image'" />
        } @else {
          <mat-icon class="preview-placeholder">image</mat-icon>
        }
        @if (isLoading) {
          <div class="spinner-overlay">
            <mat-spinner [diameter]="48" color="primary"></mat-spinner>
          </div>
        }
      </div>
      <div class="mt-2 d-flex justify-content-end align-items-center gap-2">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="!generatedImage || isLoading"
          (click)="onDownload()"
        >
          <mat-icon>download</mat-icon>
          {{ 'AI_IMAGE_GENERATION.DOWNLOAD' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="!generatedImage || !selectedItem || isLoading"
          (click)="onSaveIntoItem()"
        >
          <mat-icon>download</mat-icon>
          {{ 'AI_IMAGE_GENERATION.SAVE_INTO_ITEM' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
